import CaseBanner from "./"
import { useParams } from "react-router-dom"
import { compose, withProps } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import { CASE_DETAIL_QUERY } from "../../apollo/queries"

const CaseBannerEnhanced = compose(
  withProps(() => {
    const { facilityId, caseId } = useParams()
    return {
      facilityId,
      caseId,
    }
  }),
  graphql(CASE_DETAIL_QUERY, {
    options: ({ facilityId, caseId }) => ({
      variables: { facilityId, caseId },
    }),
    props: ({ data: { error, loading, facility } }) => {
      if (error) throw error

      if (loading) return

      if (facility.contactTracingCases.length === 0) throw Error("404")

      const kase = facility.contactTracingCases[0]

      if (kase.type === "employeePositive") {
        const user = kase.subjects[0].entity

        return {
          employeeId: user.employeeId,
          role: user.healthcareRole,
          department: user.department.name,
          compliance:
            user.compliance.timeslices.full.aggregates.overall
              .compliancePercentage,
        }
      } else {
        return
      }
    },
  })
)(CaseBanner)

export default CaseBannerEnhanced
